import Parent from "parentjs/controllers/load_more_controller.js";
export default Parent;
